import { __decorate, __metadata } from "tslib";
import { appendStyle, dispatchEvent, subscribe } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/icon';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { fromEvent, switchMap, takeUntil, tap } from 'rxjs';
import { notificationViewStyle } from './notification-view.style';
let NotificationViewElement = class NotificationViewElement extends LitElement {
    constructor() {
        super(...arguments);
        this.isClose = false;
    }
    static { this.tagName = 'inch-notification-view'; }
    static { this.styles = notificationViewStyle; }
    connectedCallback() {
        super.connectedCallback();
        subscribe(this, [this.onTouch()], { requestUpdate: false });
    }
    render() {
        const classes = {
            'notification-container': true,
            warning: this.config?.warningStyle ?? false,
            error: this.config?.errorStyle ?? false,
        };
        return html `
      <div class="${classMap(classes)}">
        <div>
          <inch-button
            class="close-notification-button"
            @click="${() => dispatchEvent(this, 'closeNotification', null)}"
            size="l"
            type="secondary"
          >
            <inch-icon icon="cross8"></inch-icon>
          </inch-button>
        </div>
        <div class="notification-title">
          <span>${this.config?.title}</span>
          <div class="notification-time">${this.formatNotificationTime(this.timestamp)}</div>
        </div>
        <slot></slot>
      </div>
    `;
    }
    onTouch() {
        let distance = 0;
        return fromEvent(this, 'touchstart').pipe(switchMap((startEvent) => {
            const startPoint = startEvent.touches[0].clientX;
            return fromEvent(document, 'touchmove').pipe(tap((event) => {
                if (this.isClose)
                    return;
                const currentPoint = event.touches[0].clientX;
                distance = currentPoint - startPoint;
                appendStyle(this, {
                    transform: `translate3d(${distance}px, 0, 0)`,
                });
                if (Math.abs(distance) > window.innerWidth * 0.3) {
                    this.onClose(distance).catch();
                }
            }), takeUntil(fromEvent(document, 'touchend').pipe(switchMap(() => this.onResetPosition(distance)))));
        }));
    }
    async onResetPosition(lastPosition) {
        if (this.isClose)
            return;
        await this.animate([
            { transform: `translate3d(${lastPosition}px, 0, 0)` },
            { transform: `translate3d(0, 0, 0)` },
        ], { duration: 200 }).finished;
        appendStyle(this, {
            transform: '',
        });
    }
    async onClose(lastPosition) {
        this.isClose = true;
        dispatchEvent(this, 'closeNotification', null);
        await this.animate([
            { transform: `translate3d(${lastPosition}px, 0, 0)` },
            { transform: `translate3d(${lastPosition * 10}px, 0, 0)` },
        ], { duration: 200 }).finished;
        appendStyle(this, {
            transform: `translate3d(${lastPosition * 10}px, 0, 0)`,
        });
    }
    formatNotificationTime(timestamp) {
        const date = new Date(timestamp);
        const formatTimeValue = (value) => {
            return value < 10 ? '0' + value : value;
        };
        const timeView = [
            formatTimeValue(date.getHours()),
            formatTimeValue(date.getMinutes()),
            formatTimeValue(date.getSeconds()),
        ].join(':');
        if (Date.now() - timestamp > 6 * 60 * 60 * 1000) {
            const dateView = [formatTimeValue(date.getDate()), formatTimeValue(date.getMonth() + 1)].join('.');
            return [dateView, timeView].join(' ');
        }
        return timeView;
    }
};
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], NotificationViewElement.prototype, "config", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Number)
], NotificationViewElement.prototype, "timestamp", void 0);
NotificationViewElement = __decorate([
    customElement(NotificationViewElement.tagName)
], NotificationViewElement);
export { NotificationViewElement };
//# sourceMappingURL=notification-view.element.js.map